
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    function closeStickyNavigation() {

        var $openedText = $(".don-stickyNavigation__textopened");

        $openedText.each(function () {
            var $item = $(this);

            $item.removeClass("don-stickyNavigation__textopened");
            $item.addClass("don-stickyNavigation__textclosed");
            $(this.parentNode).removeClass("don-stickyNavigation__itemopened");
        });

        $(".don-stickyNavigation__close").addClass("don-stickyNavigation__closebuttonhide");
    }

    function openStickyNavigation() {

        var $openedText = $(".don-stickyNavigation__textclosed");

        $openedText.each(function () {
            var $item = $(this);

            $item.addClass("don-stickyNavigation__textopened");
            $item.removeClass("don-stickyNavigation__textclosed");
            $(this.parentNode).addClass("don-stickyNavigation__itemopened");
        });

        $(".don-stickyNavigation__close").removeClass("don-stickyNavigation__closebuttonhide");
    }

    $(document).ready(function () {
        var closeItem = document.getElementById("don-stickyNavigation__close");

        if (closeItem != null) {
            closeItem.addEventListener("click", closeStickyNavigation);
        }


        $(".don-stickyNavigation__LogoCol").each(function () {
            $(this).bind("click", openStickyNavigation);
        });

        closeStickyNavigation();
    });

})(window, document, jQuery);
